<template>
	<div class="text-justify">
		<div class="content-wrapper">
			<app-overlay-loader v-if="preloader" />
			<div class="row">
				<!-- Form -->
				<div class="col-lg-12">
					<form
						ref="languageForm"
						:data-url="'/transaction/lead/' + value.id"
						class="mb-0"
						:class="{ 'loading-opacity': preloader }"
					>
						<div class="row">
							<div class="col-lg-12">
								<div class="row">
									<!-- Mother Language -->
									<div class="col-md-6">
										<div class="form-group">
											<label for="input_mother_lang">
												Mother Language
											</label>
											<app-input
												id="input_mother_lang"
												type="multi-select"
												:list="LanguageLists"
												:isAnimatedDropdown="true"
												name="mother_lang"
												v-model="
													languageForm.mother_lang
												"
											/>
										</div>
									</div>
									<!-- Daily Language -->
									<div class="col-md-6">
										<div class="form-group">
											<label for="input_daily_lang">
												Daily Language
											</label>
											<app-input
												id="input_daily_lang"
												type="multi-select"
												:list="LanguageLists"
												:isAnimatedDropdown="true"
												name="daily_lang"
												v-model="
													languageForm.daily_lang
												"
											/>
										</div>
									</div>
								</div>
								<div class="row">
									<!-- Family Member who Speak Chinese at Home -->
									<div class="col-md-6">
										<div class="form-group">
											<label
												for="input_family_speaks_chinese"
												>Family Member who Speak Chinese
												at Home</label
											>
											<app-input
												id="input_family_speaks_chinese"
												type="multi-select"
												:list="familySpeaksChineseLists"
												:isAnimatedDropdown="true"
												name="family_speaks_chinese"
												v-model="
													languageForm.family_speaks_chinese
												"
											/>
										</div>
									</div>
									<!-- Reasons to Learn Chinese -->
									<div class="col-md-4">
										<div class="form-group">
											<label
												for="input_reason_to_learn_chinese"
												>Reasons to Learn Chinese</label
											>
											<app-input
												id="input_reason_to_learn_chinese"
												type="multi-select"
												:list="
													reasonToLearnChineseLists
												"
												:isAnimatedDropdown="true"
												name="reason_to_learn_chinese"
												v-model="
													languageForm.reason_to_learn_chinese
												"
											/>
										</div>
									</div>
								</div>
								<div class="row">
									<!-- Have Chinese Basic -->
									<div class="col-md-12">
										<div class="form-group">
											<label for="input_chinese_basic"
												>Have Chinese Basic</label
											>
											<app-input
												id="input_chinese_basic"
												type="radio"
												:list="yes_and_no_list"
												v-model="
													languageForm.chinese_basic
												"
											/>
										</div>
									</div>
									<!-- Place of Study -->
									<div
										class="col-md-3"
										v-if="languageForm.chinese_basic == 1"
									>
										<div class="form-group">
											<label
												for="input_chinese_basic_place"
												>Place of Study</label
											>
											<input
												id="input_chinese_basic_place"
												type="text"
												v-model="
													languageForm.chinese_basic_place
												"
												placeholder="Place of Study"
												name="chinese_basic_place"
												class="form-control"
												required
											/>
										</div>
									</div>
									<!-- Length of Study -->
									<div
										class="col-md-3"
										v-if="languageForm.chinese_basic == 1"
									>
										<div class="form-group">
											<label
												for="input_chinese_basic_duration"
												>Length of Study (years)</label
											>
											<input
												id="input_chinese_basic_duration"
												type="number"
												v-model="
													languageForm.chinese_basic_duration
												"
												placeholder="Length of Study"
												name="chinese_basic_duration"
												class="form-control"
												required
											/>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- Submit and Clear button -->
						<div class="mt-5 action-buttons">
							<button
								type="submit"
								class="btn btn-primary mr-2"
								:disabled="submitLanguageFormDisabled"
								@click.prevent="submitLanguageForm"
							>
								{{ $t("submit") }}
							</button>
							<!-- <button
								type="submit"
								class="btn btn-secondary"
								@click.prevent="clearLanguageForm"
							>
								{{ $t("clear") }}
							</button> -->
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { LanguageFormMixin } from "./LanguageFormMixin";
import GlobalHelperMixin from "../../../../../../Mixins/global/GlobalHelperMixin";

export default {
	mixins: [LanguageFormMixin, GlobalHelperMixin],
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			submitLanguageFormDisabled: true,
			originalLanguageForm: {},
			languageForm: {
				mother_lang: this.value.mother_lang,
				daily_lang: this.value.daily_lang,
				family_speaks_chinese: this.value.family_speaks_chinese,
				reason_to_learn_chinese: this.value.reason_to_learn_chinese,
				chinese_basic: this.value.chinese_basic,
				chinese_basic_place: this.value.chinese_basic_place,
				chinese_basic_duration: this.value.chinese_basic_duration,
			},
			consentForm: {
				is_parents_agree_0: this.value.is_parents_agree_0 ?? 0,
				is_parents_agree_1: this.value.is_parents_agree_1 ?? 0,
				is_parents_agree_2: this.value.is_parents_agree_2 ?? 0,
			},
			LanguageLists: [],
			dailyLangLists: [],
			familySpeaksChineseLists: [
				{ id: 1, value: "Father" },
				{ id: 2, value: "Mother" },
				{ id: 3, value: "Grandfather" },
				{ id: 4, value: "Grandmother" },
				{ id: 5, value: "Brother" },
				{ id: 6, value: "Sister" },
				{ id: 7, value: "Uncle" },
				{ id: 8, value: "Auntie" },
				{ id: 9, value: "Cousin" },
				{ id: 10, value: "Others" },
			],
			reasonToLearnChineseLists: [
				{ id: 1, value: "Interest" },
				{ id: 2, value: "School" },
				{ id: 3, value: "Parents" },
				{ id: 4, value: "Language Skills" },
				{ id: 5, value: "Study Abroad" },
				{ id: 6, value: "Others" },
			],
			yes_and_no_list: [
				{ id: 0, value: "No" },
				{ id: 1, value: "Yes" },
			],
		};
	},
	created() {
		this.originalLanguageForm = JSON.parse(
			JSON.stringify(this.languageForm)
		);
	},
    mounted() {
		this.getLanguages();
	},
	methods: {
        async getLanguages() {
			try {
				const response = await axios.get("/master/language"); // Sesuaikan dengan endpoint Anda
				this.LanguageLists = response.data.data.map((lang) => ({
					id: lang.language_id, // Sesuaikan dengan field dari API
					value: lang.name, // Sesuaikan dengan field dari API
				}));
			} catch (error) {
				console.error("Error fetching languages:", error);
			}
		},
		// LANGUAGE FORM
		beforeSubmitLanguageForm() {
			this.preloader = true;
		},
		submitLanguageForm() {
			// Handle form submission here
			const fieldsToCheck = [
				{
					condition: this.languageForm.chinese_basic == 1,
					requiredFields: [
						"chinese_basic_place",
						"chinese_basic_duration",
					],
					errorMessage: "Please select {field}",
				},
			];

			let allFieldsValid = true; // Assume all fields are valid initially

			for (const fieldGroup of fieldsToCheck) {
				if (fieldGroup.condition) {
					for (const field of fieldGroup.requiredFields) {
						if (!this.languageForm[field]) {
							this.$toastr.e(
								fieldGroup.errorMessage.replace(
									"{field}",
									field.replace("_", " ")
								)
							);
							allFieldsValid = false; // Set to false if any field is not valid
						}
					}
				}
			}

			if (allFieldsValid) {
				this.originalLanguageForm = JSON.parse(
					JSON.stringify(this.languageForm)
				);
				this.submitLanguageFormDisabled =
					JSON.stringify(this.languageForm) ===
					JSON.stringify(this.originalLanguageForm);

				this.saveLanguageForm(this.languageForm);
			}
		},
		afterSuccessLanguageForm(res) {
			this.$toastr.s(res.data.message);
			// this.clearLanguageForm();
		},
		afterFinalResponseLanguageForm() {
			this.preloader = false;
			this.scrollToTop(false);
		},
		afterErrorLanguageForm(res) {
			if (res === undefined) {
				return;
			} else if (res.data === undefined) {
				return;
			} else if (res.data.message === undefined) {
				return;
			} else {
				this.$toastr.e(res.data.message);
			}
		},
		clearLanguageForm() {
			// Clear form fields here
			this.languageForm = {};
			// this.basicInfo.custom_file = null;
		},
	},
	watch: {
		languageForm: {
			handler: function (val) {
				// parse to int
				val.chinese_basic = parseInt(val.chinese_basic);

				// Check if languageForm has changed
				const isLanguageFormChanged =
					JSON.stringify(val) !==
					JSON.stringify(this.originalLanguageForm);

				// Update the submitLanguageFormDisabled based on the change status
				this.submitLanguageFormDisabled = !isLanguageFormChanged;
			},
			deep: true,
		},
	},
};
</script>

<style scoped>
.ml-40 {
	margin-left: 40px; /* You can adjust the margin value as needed */
}
.mt-8 {
	margin-top: 40px;
}
/* .form-control {
	border: 3px solid;
} */
.required-star {
	color: red;
}
</style>
